// images.ts
const R2_BASE_URL = "https://assets.thenewscc.com.br";

export const IMAGES = {
    // Logos
    logos: {
        oldNews: `${R2_BASE_URL}/logo-the-news.png`,
        news: `${R2_BASE_URL}/nova-logo-the-news-recortada.png`,
        main: `${R2_BASE_URL}/logo0606.png`,
        thebizness: `${R2_BASE_URL}/logos/thebizness.png`,
    },

    // New Logos
    newLogos: {
        theNews: `${R2_BASE_URL}/newLogo.png`,
        theNewsWhite: `${R2_BASE_URL}/newLogoWhite.png`,
    },

} as const;

export type ImageKey = keyof typeof IMAGES;
export type LogoKey = keyof typeof IMAGES.logos;
export type IconKey = keyof typeof IMAGES.newLogos;
